import { ChangeDetectionStrategy, Component, Inject, TrackByFunction } from '@angular/core'
import type { Plan } from '@flocasts/flosports30-types/dist/subscriptions'
import { combineLatest } from 'rxjs'
import { map } from 'rxjs/operators'
import { LOGGER_SERVICE } from '../../../logger/logger.config'
import { LoggerService } from '../../../logger/logger.interface'
import { CouponService } from '../../../shared/services/coupon.service'
import { ProductService } from '../../../shared/services/product.service'
import { buildBilledAsLanguage, buildPlanData } from './legacy-plans.utility'

@Component({
  selector: 'flo-legacy-plans',
  templateUrl: './legacy-plans.component.html',
  styleUrls: ['./legacy-plans.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegacyPlansComponent {
  constructor(
    @Inject(LOGGER_SERVICE) private readonly logger: LoggerService,
    private readonly productService: ProductService,
    private readonly couponService: CouponService
  ) {}

  // Removed 'Show USD' as part of CXP-4374
  private selectedPlan$ = this.productService.selectedPlan$.pipe(
    map(plan => {
      if (!plan) return undefined
      return { ...plan, billingValueProp: buildBilledAsLanguage(plan.yearly) }
    })
  )

  // Caution: combineLatest with more than 6 args loses types
  // If you add more args to this combineLatest please break it up into multiple observables to preserve types
  public config$ = combineLatest([
    this.couponService.coupon$,
    this.productService.plans$,
    this.selectedPlan$,
    this.productService.hasOneShownPlan$,
    this.productService.planProps$,
    this.productService.savingsProp$
  ]).pipe(
    map(([coupon, planData, selectedPlan, hasOneShownPlan, valueProps, savingsProps]) => {
      if (!planData || planData.plans.length === 0) {
        this.logger.fatal('Plan Data Empty', { planData })
      }

      return {
        selectedPlan: selectedPlan as Plan & { billingValueProp: string },
        coupon,
        plans: buildPlanData(planData.plans, coupon),
        hasOneShownPlan,
        valueProps,
        savingsProps
      }
    })
  )

  // todo: update to use trackById
  trackByConfigPlan: TrackByFunction<any> = (index: number, item: any) => {
    return item.yearly
  }
}
